// Single source of truth for money formatting across the app.
// All money in Champion's Choice is USD — symbol "$", no locale-specific
// separators/symbols beyond en-US grouping. Matches the flooring behaviour
// every call site already used before this helper existed
// (`$${Math.floor(amount).toLocaleString('en-US')}`), so adopting it in a
// component is a no-op visually.
//
// Returns null (not "$NaN"/"$undefined") when amount is missing or not a
// finite number, so callers can decide whether to hide the field entirely -
// important while backend fields like prize_amount/entry_cost are still
// rolling out and may be absent on a given payload.
export const formatUSD = (amount) => {
  const num = Number(amount);
  if (amount === null || amount === undefined || Number.isNaN(num)) {
    return null;
  }
  return `$${Math.floor(num).toLocaleString("en-US")}`;
};
